import type { FC } from 'react';
import { connect, type MapStateToProps } from 'react-redux';
import { compose } from '@reduxjs/toolkit';

import type { ReduxState } from 'app/redux/types';

import { withinBettingContext } from 'app/contexts/betting';
import { Breadcrumb, MatchTable } from 'app/modules/Betting';
import type { GridSubheaderBreadcrumbProps } from 'app/modules/Betting/components/Breadcrumb';
import type { GridSubheaderBreadcrumbs } from 'app/redux/betting-presentation/grid/selectors';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type BettingContextProps = any;

type TournamentTableProps = {
  sportId: number;
  tournamentId: number;
  matchIds: number[];
  showGridColumns: boolean;
};

type StoreProps = {
  subheaderComponent: FC<GridSubheaderBreadcrumbProps>;
  breadcrumbs: GridSubheaderBreadcrumbs;
};

const createMapStateToProps: MapStateToProps<
  StoreProps,
  BettingContextProps & TournamentTableProps,
  ReduxState
> = (state: ReduxState, {
  $betting: {
    grid: {
      selectors: {
        gridSubheaderBreadcrumbSelector,
      },
    },
  },
  matchIds,
}) => {
  return {
    subheaderComponent: Breadcrumb,
    breadcrumbs: gridSubheaderBreadcrumbSelector(state, [...matchIds][0]),
  };
};

export const TournamentTable = compose<FC<TournamentTableProps>>(
  withinBettingContext,
  connect(createMapStateToProps),
)(MatchTable);
